import * as Yup from "yup";
import { useFormik } from "formik";
import { V3Button } from "../Button";
import { RightAlignPanel } from "../ReusableStyledComponents/RightAlignPanel";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { V3ModalBase } from "../V3ModalBase";
import { VerticalSpacing } from "../VerticalSpacing";
import { V3TextInput } from "../TextInput/V3TextInput";
import { V3ButtonColor } from "../Button/V3Button.types";
import { InputWithText } from "../V3ModalUpdateSlug/V3ModalUpdateSlug.styles";

interface V3ModalUpdateSlugProps {
    modalOpen: boolean;
    onCloseHandler: () => void;
    onLinkUpdate: (slug: string) => void;
    currentLink: string;
    baseUrl: string;
    title: string;
    description: string;
}

const SLUG_REGEX = /^[\w-]+$/;

export const V3ModalUpdateLink = ({ modalOpen, baseUrl, currentLink, title, description, onCloseHandler, onLinkUpdate }: V3ModalUpdateSlugProps) => {
    const formik = useFormik<{ name: string }>({
        enableReinitialize: true,
        initialValues: {
            name: currentLink
        },
        onSubmit: async (data) => {
            onLinkUpdate(data.name);
            onCloseHandler();
        },
        validationSchema: Yup.object().shape({
            name: Yup.string()
                .required("Please enter a link")
                .matches(SLUG_REGEX, { message: "Use only letters and numbers (no spaces or special characters)" })
        })
    });

    return (
        <V3ModalBase isOpen={modalOpen} onClose={onCloseHandler} title={title}>
            <VerticalSpacing bottom={32}>
                <V3BodyGrey35>{description}</V3BodyGrey35>
            </VerticalSpacing>
            <form onSubmit={formik.handleSubmit}>
                <InputWithText>
                    <div>
                        <V3BodyGrey35>{baseUrl.replace("https://", "").replace("http://", "")}</V3BodyGrey35>
                    </div>
                    <div>
                        <V3TextInput
                            name="name"
                            placeholder="e.g. jonhdoe"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.name}
                            error={formik.errors.hasOwnProperty("name") && formik.touched.hasOwnProperty("name") ? formik.errors.name : undefined}
                        />
                    </div>
                </InputWithText>
                <VerticalSpacing top={24}>
                    <RightAlignPanel>
                        <div>
                            <V3Button text="Cancel" color={V3ButtonColor.secondary} onClick={onCloseHandler} />
                        </div>
                        <div>
                            <V3Button text="Confirm" type="submit" />
                        </div>
                    </RightAlignPanel>
                </VerticalSpacing>
            </form>
        </V3ModalBase>
    );
};
